import { Media } from "./media";

export interface User {
    id: number;
    name: string;
    email: string;
    first_name: string;
    last_name: string;
    birthdate: string;
    phone: string;
    document_id: string;
    description: string;
    slug: string;
    role: any[];
    avatar: Media[];
    club: number[];
    teams: number[];
    reference_id: number;
    status: number;
    garmin_last_refresh: string;
    garmin_access_token: string;
    garmin_refresh_token: string;
    garmin_expires_in: string;
    garmin_scope: string;
    garmin_jti: string;
    garmin_refresh_token_expires_in: string;
    garmin_user_id: string;
    created: Date,
    changed: Date
}

export const emptyUser: User = {
    id: 0,
    name: '',
    email: '',
    first_name: '',
    last_name: '',
    birthdate: '',
    phone: '',
    document_id: '',
    description: '',
    slug: '',
    role: [],
    avatar: [],
    club: [],
    teams: [],
    status: 0,
    reference_id: 0,
    garmin_last_refresh: '',
    garmin_access_token: '',
    garmin_refresh_token: '',
    garmin_expires_in: '',
    garmin_scope: '',
    garmin_jti: '',
    garmin_refresh_token_expires_in: '',
    garmin_user_id: '',
    created: new Date(),
    changed: new Date()
}

export interface UserWearables {
    garmin_access_token: string;
    garmin_refresh_token: string;
    garmin_expires_in: string;
    garmin_scope: string;
    garmin_jti: string;
    garmin_refresh_token_expires_in: string;
    garmin_user_id: string;
    garmin_last_refresh: string;
}

export const emptyUserWearables = {
    garmin_access_token: '',
    garmin_refresh_token: '',
    garmin_expires_in: '',
    garmin_scope: '',
    garmin_jti: '',
    garmin_refresh_token_expires_in: '',
    garmin_user_id: '',
    garmin_last_refresh: ''
}